import type { Locale } from '../types'

/**
 * Client Review — Revision 04: sport-specific fields and metrics.
 * Highest-priority layer of `t()`.
 */
export const review04Strings: Record<Locale, Record<string, string>> = {
  'pt-BR': {
    'sport.profile.title': 'Perfil esportivo',
    'sport.profile.note':
      'Privado por padrão. Você escolhe em Privacidade o que aparece no perfil público.',
    'sport.records.title': 'Registros',
    'sport.field.derived': 'Calculado automaticamente',
    'sport.field.tenureHint': 'Calculado a partir da data de graduação',
    'sport.field.optional': 'Opcional',
    'sport.field.textPlaceholder': 'Não informado',
    'sport.metric.optionalEmpty': 'Opcional · sem registro',
    'sport.metric.derivedHint': 'Calculado a partir de “{source}”. Não é preenchido manualmente.',
    'sport.metric.raceDistance': 'Recorde por distância de prova',
    'sport.group.hint': 'Registrado em conjunto: vitórias, derrotas e empates.',
    'sport.group.history': 'Histórico do cartel',
  },
  'en-US': {
    'sport.profile.title': 'Sport profile',
    'sport.profile.note': 'Private by default. You choose in Privacy what appears on your public profile.',
    'sport.records.title': 'Records',
    'sport.field.derived': 'Calculated automatically',
    'sport.field.tenureHint': 'Calculated from the graduation date',
    'sport.field.optional': 'Optional',
    'sport.field.textPlaceholder': 'Not provided',
    'sport.metric.optionalEmpty': 'Optional · no record',
    'sport.metric.derivedHint': 'Calculated from “{source}”. Never entered manually.',
    'sport.metric.raceDistance': 'Record per race distance',
    'sport.group.hint': 'Recorded together: wins, losses and draws.',
    'sport.group.history': 'Record history',
  },
}
